<div class="rs-panel-big rs-bg-c2">
  <p class="rs-tit4">
    <span class="rs-flex">
      <span class="rs-padding-right1"
        ><i class="icon-Smartphone icon-lh" aria-hidden="true"></i
      ></span>
      {{ productSplitIdentifier }}
    </span>
  </p>
  <ng-container
    *ngFor="
      let categoryDetail of categoryDetails;
      index as categoryDetailsIndex
    "
  >
    <my-bill-odb-category-details-identifier
      [validFor]="categoryDetail.validFor"
    ></my-bill-odb-category-details-identifier>
    <div
      class="rs-entrypoint-container"
      *ngIf="categoryDetail.sections.length > 0"
    >
      <ng-container
        *ngFor="let section of categoryDetail.sections; index as sectionIndex"
      >
        <a
          (click)="navigateToL4(section, categoryDetailsIndex, sectionIndex)"
          attr.data-cy="{{
            section.amount
              ? 'myBillOdbThirdPartyLvl3LinkLvl4'
              : 'myBillOdbThirdPartyLvl3LinkLvl4NoAmount'
          }}"
          data-tms-event="link-click"
          data-tms-link-zone="mybill.detail.thirdParty.details"
          data-tms-link-name="navigate to thirdParty lvl 4 section"
          class="rs-entrypoint"
        >
          <span class="rs-entrypoint-title"
            >{{ section.description }} {{ getItemsQuantity(section.items) }}
          </span>
          <span class="rs-entrypoints-extra">
            <strong>
              <px-currency-amount
                [amount]="section.amount"
                *ngIf="section.amount"
              ></px-currency-amount
              ><span *ngIf="!section.amount">...</span></strong
            >
          </span>
          <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
        </a>
      </ng-container>
    </div>
  </ng-container>
</div>
<div
  class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
  my-bill-odb-total
  [amount]="amount"
></div>

<my-bill-modal-login-required
  [showModal]="showModal"
  [redirectToLoginLink]="redirectLink"
  *ngIf="showModal"
  (hideModal)="onCancel()"
>
</my-bill-modal-login-required>
